// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import {
  Home,
  CalendarDays,
  Refrigerator,
  ShoppingCart,
  TrendingUp,
  BookOpen,
  MoreHorizontal,
  type LucideIcon,
} from "lucide-react"

export interface NavItem {
  to: string
  labelKey: string
  icon: LucideIcon
}

/**
 * Shared Today · Plan · Pantry · Shop · Insights · More order for both the
 * left rail and the mobile bottom nav (Pantry promoted to a top-level area
 * in the 2026-08 Pantry batch; Amy stays a floating button on mobile, so
 * six compact tabs keep their visual balance).
 */
export const navItems: NavItem[] = [
  { to: "/app/today", labelKey: "nav.today", icon: Home },
  { to: "/app/plan", labelKey: "nav.plan", icon: CalendarDays },
  { to: "/app/pantry", labelKey: "nav.pantry", icon: Refrigerator },
  { to: "/app/shop", labelKey: "nav.shop", icon: ShoppingCart },
  { to: "/app/insights", labelKey: "nav.insights", icon: TrendingUp },
  // Owner decision 2026-08-28: the Guide Center is first-class navigation,
  // not buried under More. The guides are public standalone pages (/guides,
  // outside the /app shell) — the browser back button returns to the app.
  { to: "/guides", labelKey: "nav.guides", icon: BookOpen },
  { to: "/app/more", labelKey: "nav.more", icon: MoreHorizontal },
]
